import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface EmspBoChargingSessionListEmspUserIdHeaderProps
  extends HeaderContext<
    GatewayChargingSessionModel,
    GatewayChargingSessionModel['emspUser']['id']
  > {}

export const EmspBoChargingSessionListEmspUserIdHeader =
  (): // props: EmspBoChargingSessionListEmspUserIdHeaderProps,
  ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return t('delmonicos-shared-sdk.outputs-emsp-user.id');
  };
